import PropTypes from 'prop-types'
import { translationPropType } from '../common/translation-prop-type'

export const externalLinkPropType = PropTypes.shape({
    description: translationPropType,
    href: translationPropType.isRequired,
    title: translationPropType
})
